
























import VueOptions from '@utils/VueOptions'
import WizardService from '@services/Wizard'
import FormProductSampling from './FormProductSampling'
import FormOnSiteSpace from './FormOnSiteSpace'
import FormVideoWall from './FormVideoWall'
import FormSocialPost from './FormSocialPost'

settings =
  name: "CreativeStep"

  vue:
    props: ['wizard']
    mixins: [WizardService.step()]

    components: {
      FormProductSampling,
      FormOnSiteSpace,
      FormVideoWall,
      FormSocialPost
    }

    methods:
      validateStep: ->
        @validateProductSamplingCreativeList()
        @validateOnSiteSpaceCreativeList()
        @validateVideoWallCreativeList()
        @validateSocialPostCreativeList()

      validateProductSamplingCreativeList: ->
        return unless @wizard.creativeHasSampling
        @validateProductSamplingCreative(descriptor.activation_snapshot) for descriptor in @wizard.creatives.product_sampling
      validateProductSamplingCreative: (activation) ->
        { food, drink, other_cpg, promo } = activation.distributing
        isDistributingMoreThanOne = [food, drink, other_cpg].filter(Boolean).length > 1

        if not food and not drink and not other_cpg and not promo
          @wizard.setFormError 'product_sampling_distribution', 'Please choose'
          @wizard.setModelError 'product_sampling_distribution', 'Select what you will be distributing'

        if isDistributingMoreThanOne
          @wizard.setFormError 'product_sampling_distribution', 'You can distribute food, drinks or other CPG but not more than one'
          @wizard.setModelError 'product_sampling_distribution', 'You can distribute food, drinks or other CPG but not more than one'

      validateOnSiteSpaceCreativeList: ->
        return unless @wizard.creativeHasOnSiteSpace
        @validateOnSiteSpaceCreative(descriptor.activation_snapshot) for descriptor in @wizard.creatives.onsite_space
      validateOnSiteSpaceCreative: (activation) ->

      validateVideoWallCreativeList: ->
        return unless @wizard.creativeHasVideoWall
        @validateVideoWallCreative(descriptor.activation_snapshot) for descriptor in @wizard.creatives.video_wall
      validateVideoWallCreative: (activation) ->

      validateSocialPostCreativeList: ->
        return unless @wizard.creativeHasSocialPost
        @validateSocialPostCreative(descriptor.activation_snapshot) for descriptor in @wizard.creatives.social_media_post
      validateSocialPostCreative: (activation) ->

export default VueOptions.vue settings
